<mat-dialog-content class="p-4">
    <div class="flex justify-between items-start">
        <div>
            <h2 class="text-2xl font-semibold">Items Relacionados</h2>
            <p class="text-sm text-gray-600">Para el item:</p>
            <div class="flex items-center gap-3 mt-3">
                <img *ngIf="item?.productImage" [src]="item.productImage" alt=""
                    class="w-16 h-16 object-cover rounded" />
                <div class="flex flex-col text-sm text-gray-700 gap-0.5">
                    <div class="font-medium text-base">{{ item?.description || item?.name }}</div>
                    <div *ngIf="item?.id">ID: {{ item.id }}</div>
                    <div *ngIf="item?.dimensions">Dimensiones: {{ item.dimensions }}</div>
                    <div *ngIf="item?.thickness">Espesor: {{ item.thickness }}mm</div>
                    <div *ngIf="item?.color?.name">Color: {{ item.color.name }}</div>
                    <div *ngIf="item?.product">{{ item.product.category }} / {{ item.product.finish }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-4">
        <div class="flex flex-row flex-wrap justify-start gap-4">
            <app-custom-input [(value)]="search" placeholder="Buscar por ID (FIBFPLC0041) o descripción" (enter)="searchTriggered()">
            </app-custom-input>
            <app-button label="Buscar" (clickButton)="searchTriggered()" [disabled]="search.length < 3"></app-button>
            <app-button label="Limpiar filtros" color="red-500" icon="fi-rr-eraser"
                (click)="clearSearch()"></app-button>
        </div>
    </div>

    <div class="mt-3 flex items-center justify-between">
        <div>{{ totalItems }} items relacionados</div>
        <div *ngIf="loading" class="text-sm text-gray-500">Cargando...</div>
    </div>

    <div class="mt-4 max-h-96 overflow-auto">
        <div *ngFor="let i of items" class="flex items-center justify-between p-3 border-b">
            <div class="flex items-center gap-3">
                <img *ngIf="i.productImage" [src]="i.productImage" class="w-12 h-12 object-cover rounded" />
                <div class="flex flex-col gap-0.5 text-xs">
                    <div class="truncate font-medium text-sm">{{ i.description || i.name }}</div>
                    <div class="text-gray-700">ID: {{ i.id }}</div>
                    <div class="text-gray-700">Dimensiones: {{ i.dimensions }}</div>
                    <div class="text-gray-700">Espesor: {{ i.thickness }}mm</div>
                    <div *ngIf="i.color?.name" class="text-gray-700">Color: {{ i.color.name }}</div>
                </div>
            </div>
        </div>
        <div *ngIf="items.length === 0" class="p-4 text-gray-500">No hay items relacionados para este item ...</div>
    </div>

    <div class="flex items-center justify-between mt-3 text-sm" *ngIf="totalItems > rows">
        <div>Mostrando {{ startDisplay }} - {{ endDisplay }} de {{ totalItems }}</div>
        <div class="flex gap-2">
            <button class="rounded-2xl px-3 py-1 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400" [disabled]="page === 0" (click)="changePage(-1)">Anterior</button>
            <button class="rounded-2xl px-3 py-1 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400" [disabled]="(page + 1) * rows >= totalItems" (click)="changePage(1)">Siguiente</button>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="p-4 flex justify-end gap-2">
    <button
        class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
        (click)="close()">
        <span class="text-base">Cerrar</span>
        <i class="fi-rr-cross-small text-base flex"></i>
    </button>
</mat-dialog-actions>
